import { WEBSOCKET_CONNECTED_EVENT, WEBSOCKET_FAILED_EVENT } from "constants/events";
import { ReactElement, useEffect, useState } from "react";
import { IMessage, useStompClient } from "react-stomp-hooks";
import { v4 as uuidv4 } from "uuid";
import { SubscriptionInfos, SubscriptionSocket } from "./SubscriptionSocket";

type Props = {
  handleApplicatEvent: (event: any) => void;
  authToken: string;
  subscriptions: SubscriptionInfos[];
  children: ReactElement;
};
const EVENT_SUB_STATUS_SUBSCRIBED = "SUBSCRIBED";

export function SubscriptionsHook({
  handleApplicatEvent,
  authToken,
  subscriptions,
  children,
}: Props) {
  const client = useStompClient();
  const subbedEventsAndFilters: React.JSX.Element[] = [];
  const [isWebSocketAuthenticated, setIsWebSocketAuthenticated] = useState(false);

  for (let i = 0; i < subscriptions.length; ++i) {
    subbedEventsAndFilters[i] = (
      <SubscriptionSocket
        key={i}
        subscriptionInfo={subscriptions[i]}
        handleWSError={handleApplicatEvent}
      />
    );
  }

  useEffect(() => {
    if (!client) return;

    const subscriptionReceiptId = uuidv4();
    const messageReceiptId = uuidv4();
    client.watchForReceipt(subscriptionReceiptId, () =>
      client.publish({
        destination: "/to-applicat/authenticate",
        body: authToken,
        headers: { receipt: messageReceiptId },
      })
    );
    const subscriptionsChannel = client.subscribe(
      "/user/from-applicat/subscription",
      (message: IMessage) => {
        const jsonMessage = JSON.parse(message.body);
        if (jsonMessage.authenticated !== undefined) {
          setIsWebSocketAuthenticated(jsonMessage.authenticated);
          if (jsonMessage.authenticated) {
            handleApplicatEvent({ event: { type: WEBSOCKET_CONNECTED_EVENT }, data: { message: "WebSocket Authentication Successful.", code: "AUTH-OK" } });
          } else {
            handleApplicatEvent({ event: { type: WEBSOCKET_FAILED_EVENT }, data: { message: "WebSocket Authentication Error", code: "AUTH001" } });
          }
        }

        if (jsonMessage.eventSubscription !== undefined) {
          if (jsonMessage.status === EVENT_SUB_STATUS_SUBSCRIBED) {
            handleApplicatEvent({ event: { type: WEBSOCKET_CONNECTED_EVENT }, data: { message: "WebSocket Event Subscription Successful. "+jsonMessage.eventSubscription.eventType, code: "SUB-OK" } });
          } else {
            handleApplicatEvent({ event: { type: WEBSOCKET_FAILED_EVENT }, data: { message: "WebSocket Subscription Error", code: "SUBCH001" } });
          }
        }
      },
      { receipt: subscriptionReceiptId }
    );
    const eventsChannel = client.subscribe(
      "/user/from-applicat/events",
      (message: IMessage) => {
        const jsonMessage = JSON.parse(message.body);
        handleApplicatEvent(jsonMessage);
      }
    );

    return () => {
      try {
        subscriptionsChannel.unsubscribe();
      } catch {
        // ignore
      }
      try {
        eventsChannel.unsubscribe();
      } catch {
        // ignore
      }
    };
  }, [client]);

  return (
    <>
      {isWebSocketAuthenticated && subbedEventsAndFilters}
      {children}
    </>
  );

}
